<template>
    <div class="setting_list">
        <div class="setting_list_container">
            <setting_list_item
                v-for="(item, index) in userSettings"
                :key="'setting_list_item_' + index"
                :settingItem="item"
                @click_switch_item="clickSwitchItem"
            />
        </div>
    </div>
</template>

<script>

import setting_list_item from "./SettingListItem.vue";
import {createHelpers} from "vuex-map-fields";
import getObjectPathProperty from "../../mixins/getObjectPathProperty";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "setting_list",
    components: {
        setting_list_item,
    },
    data() {
        return {}
    },
    beforeMount() {
        EventBus.$on('change_user_setting', this.changeUserSetting);
    },
    beforeUnmount() {
        EventBus.$off('change_user_setting', this.changeUserSetting);
    },
    methods: {
        clickSwitchItem(itemSwitch, state) {
            if(this.listCookieSettingsName.includes(itemSwitch.parameter)) {
                this.changeSettingCookie(itemSwitch, state);
            } else {
                this.changeSettingUser(itemSwitch, state);
            }
        },
        changeSettingCookie(itemSwitch, state){
            const userSettings = this.userSettings.filter(item => {
                return this.listCookieSettingsName.includes(item.parameter);
            })

            userSettings.forEach(item =>{
                if(item.parameter === itemSwitch.parameter) {
                    item.state = state;
                }
            })
            this.$store.dispatch('user/CHANGE_USER_SETTING_COOKIE', {
                user: this.user,
                bodyRequest: userSettings
            });
        },
        changeSettingUser(itemSwitch, state){
            let bodyRequest = {};
            bodyRequest[itemSwitch.parameter] = state;
            const userSettings = this.userSettings.filter(item => {
                return !this.listCookieSettingsName.includes(item.parameter);
            })
            userSettings.forEach(item =>{
                if(item.parameter !== itemSwitch.parameter) {
                    bodyRequest[item.parameter] = item.state;
                }
            })
            this.$store.dispatch('user/CHANGE_USER_SETTING', {
                user: this.user,
                bodyRequest: bodyRequest
            });
        },
        changeUserSetting(params){
            let respData = null;
            if(this.getObjectPathProperty(params, 'resp.data.data')){
                respData = params.resp.data.data;
                Object.keys(respData).forEach(keyResp => {
                    this.userSettings.forEach(item => {
                        if(item.parameter === keyResp) {
                            item.state = respData[keyResp];
                        }
                    })
                })
            }
        },
    },
    computed: {
        ...mUser([
            'user',
            'userSettings',
            'listCookieSettingsName'
        ]),
    }
}
</script>
